import createCollectionResource from 'src/actions/shared/createResource';

export class ScheduledReport {
  id: string;
  name: string;
  frequency: string;
  agentId: string;
  createdAt: string;
}

const scheduledReportsResource = createCollectionResource<ScheduledReport>({
  name: 'scheduledReports',
  endpoint: {
    broadcastTopic: 'v1/orgs/:orgId/scheduledReports/:id',
    broadcastDeleteTopic: 'v1/orgs/:orgId/scheduledReports/:id/event/delete',
    collectionBroadcastTopic: 'v1/orgs/:orgId/scheduledReports/+',
    collectionBroadcastDeleteTopic: 'v1/orgs/:orgId/scheduledReports/+/event/delete',
    fetchAllUrl: '/api/reporting/v1/orgs/:orgId/scheduled-reports',
    fetchUrl: '/api/reporting/v1/orgs/:orgId/scheduled-reports/:id',
    addUrl: '/api/reporting/v1/orgs/:orgId/scheduled-reports',
    updateUrl: '/api/reporting/v1/orgs/:orgId/scheduled-reports/:id',
    deleteUrl: '/api/reporting/v1/orgs/:orgId/scheduled-reports/:id',
  },
  type: ScheduledReport,
  options: {
    toastMessages: {
      onRemove: () => `Deleted scheduled report`,
    },
  },
});

export default scheduledReportsResource;
